import { axiosGet } from "../../react_axios/Axios"
import { GET_CURRENT_AWARD_DETAILS_ACTION_TYPE, headers, getCurrentAwardDetailsUrl, GET_ACTIVE_JURY_DETAILS_ACTION_TYPE, getActiveJuryDetailsUrl, user_id } from "../../utils/constants"
import moment from 'moment';

export const getCurrentAwardDetails_action = (award_event_profile_id, award_event_profile_uid) => async (dispatch) => {
    try {
        const mapdata = {
            award_event_profile_id: award_event_profile_id,
            award_event_profile_uid: award_event_profile_uid
        }
        const res = await axiosGet(getCurrentAwardDetailsUrl, mapdata, headers);

        dispatch({
            type: GET_CURRENT_AWARD_DETAILS_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getActiveJuryDetails_action = (award_event_id) => async (dispatch) => {
    try {
        const mapdata = {
            user_id: user_id,
            award_event_id: award_event_id,
        }
        const res = await axiosGet(getActiveJuryDetailsUrl, mapdata, headers);

        dispatch({
            type: GET_ACTIVE_JURY_DETAILS_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};